export default __webpack_public_path__ + "media/trail/rotate-right-green-aef4d2f6.svg";